import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EdSectionFolderIcon from '@/courses/components/ed-section-folder-icon/ed-section-folder-icon.vue';
import EdTreeViewContainer from './ed-treeview-container.vue';

@Component({
  components: {
    EdSectionFolderIcon,
    EdTreeViewContainer,
  }
})
export default class EdTreeView extends Vue {
  
  @Prop() readonly items: any;

  public initiallyOpen : any = ['public'];
  public tree : any = [];

}

